import { Typography, Box } from "@mui/material";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import classes from "./ContentMapping.module.css";
import EmptyView from "../../../Component/EmptyView/EmptyView";


export default function ContentMappingHistory({ historyData, getContentHistory }) {
   if (!historyData || historyData.length === 0 || 
    historyData.every(item => !item?.contentSuggestions || Object.keys(item.contentSuggestions).length === 0)) {
    return <EmptyView message="No ContentMap history found." />;
}
    
    const formatDateTime = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        return date.toLocaleString(undefined, {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };
    // const reversedHistoryData = [...(historyData || [])].reverse();


return (
    <Box display="flex" flexDirection="column" gap={1.5}>
        {historyData?.map((item, index) => (
            <Box key={index} className={classes.historyCard}>
                <Box className={classes.historyRow}>
                    {/* MAIN CONTENT */}
                    <Box className={classes.historyContent}>
                        <Typography className={classes.historytitle}>
                            {`Content Configuration ${historyData.length - index}`}
                        </Typography>
                        <Typography className={classes.timeRow}>
                            {formatDateTime(item?.created_at || new Date())}
                        </Typography>
                    </Box>

                    {/* ACTIONS */}
                    <Box className={classes.actions}>
                        <MUIIconButton 
                            size="small" 
                            onClick={() => { getContentHistory(item) }}
                        >
                            <VisibilityOutlinedIcon fontSize="small" />
                        </MUIIconButton>
                    </Box>
                </Box>
            </Box>
        ))}
    </Box>
);
}